// extracted by mini-css-extract-plugin
export default {"emptyList":"EmptyList_emptyList__g3uuR"};